import { Extension } from '@tiptap/core';

interface LinkUiOptions {
  showTarget?: boolean;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    linkUi: {
      showLinkDialog: () => ReturnType;
    };
  }
}

export const LinkUi = Extension.create<LinkUiOptions>({
  name: 'linkUi',

  addKeyboardShortcuts() {
    return {
      'Mod-k': ({ editor }) => editor.commands.showLinkDialog(),
    };
  },
  addCommands() {
    return {
      showLinkDialog: () => ({ editor }) => {
        // TODO: Use a real dialog. For now we'll use setTimeout to emulate an asynchronous dialog.
        setTimeout(() => {
          // eslint-disable-next-line no-alert
          let href = prompt(t('Enter a link:'));
          // TODO: Validate href
          if (href) {
            editor.chain().focus().setLink({ href }).run();
          }
        }, 1);
        return true;
      },
    };
  },
});
